import { Injectable } from '@angular/core';
import { L10nTranslationService } from '@snack-dev/angular-l10n';

@Injectable({
  providedIn: 'root'
})
export class FormErrorsService {

  private errors: any;
  private genericError: any;

  constructor(private translation: L10nTranslationService) { }

  get all() {
    if (!this.errors) {
      this.buildErrors();
    }
    return this.errors;
  }

  get generic(): (error: any) => string {
    if (!this.genericError) {
      this.genericError = (error: any) => this.translation.translate('form-errors.invalid-field');
    }
    return this.genericError;
  }

  private buildErrors() {
    this.errors = {
      required: (error: any) => this.translation.translate('form-errors.required'),
      minlength: ({ requiredLength, actualLength }) => this.translation.translate('form-errors.min-length', { requiredLength }),
      email: (error: any) => this.translation.translate('form-errors.email'),
      ccNumber: (error: any) => this.translation.translate('form-errors.cc-number'),
      mustMatch: (error: any) => this.translation.translate('signup.password-match'),
      invalidPhone: (error: any) => this.translation.translate('form-errors.invalid-phone')
    };
  }

}
